module.exports = __webpack_public_path__ + "img/1.c0b72657.jpg";